import { useFiltersConfigContext } from "app/pages/sales-intelligence/modules/advanced-search-filtering/context/FiltersConfigContext";
import { collectFlatFilterDefaults } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/collectFilterDefaults";
import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { useFiltersUpdate } from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useFiltersUpdate";
import type { LeadsSearchFilterInstance } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilterInstance";

export const useResetAllFilters = (): VoidFunction => {
    const { filtersList } = useFiltersConfigContext<LeadsSearchFilterInstance>();
    const handleFilterUpdate = useFiltersUpdate();

    const resetAllFilters = () => {
        handleFilterUpdate(collectFlatFilterDefaults<LeadsSearchAllFiltersTypes>(filtersList));
    };

    return resetAllFilters;
};
